import { Button, Container, styled } from "@mui/material";
import { useEffect } from "react";
import PageTemplate from "../../components/template/page-template";
import { IRootState } from "../../redux/root.reducer";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { canAccessLegacyLinks } from "../../service/user-permission";
import { openLegacyUrl } from "../../shared/component/open-legacy-url";
import { IWithClassName, IWithThemeProps } from "../../theme/default.theme";
import Announcements from "./components/announcements";
import History from "./components/history";
import OtherFeatures from "./components/other-features";
import PopularFeatures from "./components/popular-features";
import { initHomeAction } from "./redux/home.actions";

const Home = ({ className }: IWithClassName) => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(initHomeAction());
    }, []);

    const role = useAppSelector(({ auth }: IRootState) => auth.user?.role);

    const hasLegacylinkAccess = canAccessLegacyLinks(role);

    return (
        <PageTemplate pageTitle="RetailStat POI Data" className={className}>
            <Container>
                <div className="header-section">
                    <h1>POI Data</h1>
                    {hasLegacylinkAccess && (
                        <div className="buttons-container">
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => openLegacyUrl("/qae/events")}
                            >
                                QAE
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => openLegacyUrl("/tools")}
                            >
                                More Tools
                            </Button>
                        </div>
                    )}
                </div>
                <Announcements />
                <PopularFeatures />
                <div className="other-features">
                    <OtherFeatures />
                    <History />
                </div>
            </Container>
        </PageTemplate>
    );
};

export default styled(Home)(({ theme }: IWithThemeProps) => ({
    h1: {
        fontSize: 64,
        fontWeight: 600,
        color: theme?.palette.action.active,
    },
    ".header-section": {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: theme?.spacing(4),
    },
    ".buttons-container": {
        display: "flex",
        gap: theme?.spacing(2),
    },
    ".other-features": {
        display: "flex",
        gap: theme?.spacing(8.5),
    },
}));
